<template>
  <div class="md_form_group_unit">
    <div class="wrapper">
      <div class="align-horizontal" :style="{width: labelWidth ? labelWidth + 'px' : 'auto'}">
        <label class="caption mb-0">{{ label }}</label>
        <img class="emphasize_dot" src="../../assets/image/ic_dot_red.png" v-if="required">
        <slot name="checkbox"></slot>
        <span class="multi_select" v-if="enable_multi_select">{{ $t('map.multi_selection') }}</span>
        <span class="multi_select" v-if="enable_multi_select_unit">{{ $t('register.unit_money2') }}</span>
        <span class="multi_select" v-if="enable_money_unit">{{ $t('register.unit_money') }}</span>
      </div>
      <slot name="checkbox_right"/>
    </div>
    <slot>
    </slot>
  </div>

</template>

<script>
export default {
  name: "MdFormGroup",
  data() {
    return {}
  },
  props: {
    label: {
      type: String,
      required: true,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    enable_multi_select: {
      type: Boolean,
      default: false
    },
    enable_money_unit: {
      type: Boolean,
      default: false
    },
    enable_multi_select_unit: {
      type: Boolean,
      default: false
    },
    labelWidth: {
      type: [Number, String],
      default: 0,
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/main/more/RegNewOpenSite1";

.emphasize_dot {
  position: relative;
  top: -10px;
  left: 1px;
  z-index: -9999;
  width: 5px;
}

.wrapper {
  display: flex;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/MdFormGroup.vue